export default __webpack_public_path__ + "static/media/SWT1170.34I-32215_-17786_0.aa078a6a.jpg";